<div class="container">
   
    <div *ngIf="!registerMode" class="info-area">
        <h1>Find your match</h1>
        <p>Come on in to view your matches... all you need to do is sign up!</p>

        <div class="button-area">
            <button *ngIf="(accountService.currentUser$ | async) === null" class="btn" (click)="toggleRegisterMode()" mat-raised-button color="primary">Register</button>
            <button  class="btn" mat-raised-button>Learn More</button>
        </div>
        
    </div>

    <div *ngIf="registerMode">
        <app-register (cancelRegister)="cancelRegiterModer($event)"></app-register>
    </div>
</div>